import axios from 'axios';
import { showTabs, selectTab } from '../common/tab/tabActions';
import consts from '../consts';
import { setErroAPI, setSuccess } from '../common/toast/toast';
import { reset as resetForm, initialize } from 'redux-form';
import DateFormat from '../common/dateFormat/DateFormat';

export function setModoTela(modo, registro = { id_estoque_local: 2 }) {
    return {
        type: 'EMBALAGEM_ENTRADA_MODO_TELA',
        payload: {
			modo: modo,
			registro: registro
		}
    };
}

export function setAguardando(aguardando) {
    return {
        type: 'EMBALAGEM_ENTRADA_SET_AGUARDANDO',
        payload: aguardando
    };
}

export function initForm(registro) {
    return [
        initialize('embalagemEntradaForm', registro)
    ];
}

export function setFiltro(filtro) {
    return {
        type: 'EMBALAGEM_ENTRADA_FILTRO',
        payload: {
			filtro: filtro
		}
    };
}

export function getLista() {

	return (dispatch, getState) => {
		dispatch(setAguardando(true));
    	axios.get(`${consts.API_URL}/embalagemEntrada?id_cliente=${getState().auth.usuario.id_cliente || 0}
				&data_inicial=${DateFormat.formatarDataTelaParaSql(getState().embalagemEntrada.filtro.data_inicial) == 'Invalid DateTime' ? null : DateFormat.formatarDataTelaParaSql(getState().embalagemEntrada.filtro.data_inicial)}
				&data_final=${DateFormat.formatarDataTelaParaSql(getState().embalagemEntrada.filtro.data_final) == 'Invalid DateTime' ? null : DateFormat.formatarDataTelaParaSql(getState().embalagemEntrada.filtro.data_final)}`)
		.then(resp => {
			dispatch({
		        type: 'EMBALAGEM_ENTRADA_LISTADO',
		        payload: resp
		    });
			dispatch(setAguardando(false));
		}).catch(e => {
			dispatch(setAguardando(false));
			setErroAPI(e);
		});
	}
}

export function salvar(registro) {
    return (dispatch, getState) => {
		if (!registro.id) {
	        axios.post(`${consts.API_URL}/embalagemEntrada`, {
				...registro,
				id_cliente: getState().auth.usuario.id_cliente,
				id_usuario_alteracao: getState().auth.usuario.id,
				datahora_entrada: DateFormat.getDataHoraAtual(),
				quantidade: String(registro.quantidade || '').replace(',', '.'),
				minimo: String(registro.minimo || '').replace(',', '.'),
				maximo: String(registro.maximo || '').replace(',', '.')
			}).then(resp => {
				setSuccess('Operação Realizada com sucesso.');
				dispatch(getLista());
				dispatch(setModoTela('lista'));
			}).catch(e => {
				setErroAPI(e);
			});
		} else {
			axios.put(`${consts.API_URL}/embalagemEntrada`, {
				...registro,
				id_usuario_alteracao: getState().auth.usuario.id,
				datahora_entrada: DateFormat.formatarDataHoraTelaParaSql(registro.datahora_entrada),
				quantidade: String(registro.quantidade || '').replace(',', '.'),
				minimo: String(registro.minimo || '').replace(',', '.'),
				maximo: String(registro.maximo || '').replace(',', '.')
			}).then(resp => {
				setSuccess('Operação Realizada com sucesso.');
				dispatch(getLista());
				dispatch(setModoTela('lista'));
			}).catch(e => {
				setErroAPI(e);
			});
		}
    };
}

export function excluir(registro) {
    return dispatch => {
        axios.delete(`${consts.API_URL}/embalagemEntrada?id=${registro.id}`)
		.then(resp => {
			setSuccess('Operação Realizada com sucesso.');
			dispatch(getLista());
			dispatch(setModoTela('lista'));
		}).catch(e => {
			setErroAPI(e);
		});
    };
}

export function getListaFornecedor() {
	return (dispatch, getState) => {
    	axios.get(`${consts.API_URL}/fornecedor/listarSelect?id_cliente=${getState().auth.usuario.id_cliente || 0}`)
		.then(resp => {
			dispatch({
				type: 'EMBALAGEM_ENTRADA_FORNECEDOR_SELECT_LISTADO',
		        payload: resp
		    });
		}).catch(e => {
			setErroAPI(e);
		});
	}
}

export function getListaEmbalagem() {
	return (dispatch, getState) => {
    	axios.get(`${consts.API_URL}/embalagem/listarSelect?id_cliente=${getState().auth.usuario.id_cliente || 0}`)
		.then(resp => {
			dispatch({
				type: 'EMBALAGEM_ENTRADA_EMBALAGEM_SELECT_LISTADO',
		        payload: resp
		    });
		}).catch(e => {
			setErroAPI(e);
		});
	}
}

export function getListaEstoqueLocal() {
    const request = axios.get(`${consts.API_URL}/estoqueLocal/listarSelect`);
    return {
        type: 'EMBALAGEM_ENTRADA_ESTOQUE_LOCAL_SELECT_LISTADO',
        payload: request
    };
}
